import React, { lazy, useEffect } from 'react';
import PropTypes from 'prop-types';
import { hasValue } from 'globalutils/fmUtils';
import Box from '@material-ui/core/Box';
import TopActions from './TopActions';
import { compoentColumns, paymentFields } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Link = lazy(() => import(`globalcomponents/UI/Link`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`).default;
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));
const Input = lazy(() => import(`globalcomponents/UI/Input/${layout}`));
const Label = lazy(() => import(`globalcomponents/UI/FormLabel/${layout}`));

const Component = ({
  theme,
  apiStatus,
  Styled,
  paymentInformation,
  fetchPaymentInformation,
  downloadReceipt,
  receipt,
  i18n,
  topAction,
  clearState,
}) => {
  useEffect(() => {
    return () => {
      clearState();
    };
  }, []);

  useEffect(() => {
    let url = receipt ? receipt : '';
    document.getElementById(`downloadDocument`).src = url;
  }, [receipt]);

  const hasApiStatus = hasValue(apiStatus.status, 'api', fetchPaymentInformation);
  const information =
    hasApiStatus && hasApiStatus.errorMessage ? (
      <Message type="error" s message={i18n.t(hasApiStatus.errorMessage)} />
    ) : (
      i18n.t('common.tableEmptyMessage')
    );

  const generateRows = () => {
    const updatedList = paymentInformation?.paymentHistoryDtos?.map((item) => {
      var result = { ...item };
      result.receipt = item?.receiptId ? (
        <Link onClick={() => downloadReceipt({ apiId: 'downloadReceipt', data: item?.receiptId })}>Download</Link>
      ) : (
        ''
      );
      return result;
    });
    return updatedList || [];
  };

  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Styled.Wrapper>
        {topAction && <TopActions {...{ i18n, paymentInformation, Styled }} />}
        <SubHeader variant="h2" text={`${i18n.t('paymentInformation.companyInfoHeading')}`} />
        <div className="paymentInfo">
          {paymentFields.map(({ label, valueKey }, index) => (
            <FormStyle.FieldsWrapper className="fieldSection" key={index}>
              <Label variant="body1">{label}</Label>
              <FormStyle.TextWrapper>
                <Input value={paymentInformation?.[valueKey]} disabled />
              </FormStyle.TextWrapper>
            </FormStyle.FieldsWrapper>
          ))}
        </div>
        <SubHeader variant="h2" text={`${i18n.t('paymentInformation.paymentHistoryHeading')}`} />
        <Styled.TableWrapper>
          <Table
            type="client"
            defaultSortBy={{ sortBy: 'paymentId', order: 'asc' }}
            title=""
            columns={compoentColumns}
            data={generateRows()}
            emptyMessage={information}
            itemsPerPage={5}
            i18n={i18n}
            actions={[]}
          />
        </Styled.TableWrapper>

        <iframe id="downloadDocument" style={{ display: 'none' }} title="downloadDocument"></iframe>
      </Styled.Wrapper>
    </Box>
  );
};

Component.propTypes = {
  history: PropTypes.object.isRequired,
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
};

export default Component;
